import React, { useRef, useState } from 'react';
import '../assets/styles/Contact.scss';
import emailjs from '@emailjs/browser';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import TextField from '@mui/material/TextField';

function Contact() {
  const [name, setName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [message, setMessage] = useState<string>('');

  const [nameError, setNameError] = useState<boolean>(false);
  const [emailError, setEmailError] = useState<boolean>(false);
  const [messageError, setMessageError] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

 const form = useRef<HTMLFormElement>(null);

  const sendEmail = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setNameError(name === '');
    setEmailError(email === '');
    setMessageError(message === '');

    if (name !== '' && email !== '' && message !== '') {
      setIsSubmitting(true);

      const templateParams = {
        name: name,
        email: email,
        message: message
      };

      console.log('Template Params:', templateParams);
      console.log('Env Vars:', {
        serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID,
        templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      }); // Debug log

      // Safe access with fallbacks
      const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID || 'fallback_service_id';
      const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'fallback_template_id';
      const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'fallback_public_key';

      if (!serviceId || !templateId || !publicKey) {
        console.error('Missing EmailJS config—check .env');
        alert('Configuration error. Please contact me directly.');
        setIsSubmitting(false);
        return;
      }

      emailjs.send(serviceId, templateId, templateParams, publicKey)
        .then((response) => {
          console.log('SUCCESS!', response.status, response.text);
          alert('Message sent successfully!');
          setName('');
          setEmail('');
          setMessage('');
          setNameError(false);
          setEmailError(false);
          setMessageError(false);
        }, (error) => {
          console.log('FAILED...', error);
          alert('Failed to send message. Please try again.');
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    }
  };

  return (
    <div id="contact">
      <div className="items-container">
        <div className="contact_wrapper">
          <h1>Contact Me</h1>
          <p>Got a project waiting to be realized? Let's collaborate and make it happen!</p>
          <Box
            ref={form}
            component="form"
            onSubmit={sendEmail} // Handles submission on Enter or button click
            noValidate
            autoComplete="off"
            className="contact-form"
          >
            <div className="form-flex">
              <TextField
                key="name-field"
                required
                id="outlined-required-name"
                label="Your Name"
                placeholder="What's your name?"
                value={name}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  console.log('Name input:', e.target.value); // Debug log (remove later)
                  setName(e.target.value);
                  if (nameError) setNameError(false);
                }}
                error={nameError}
                helperText={nameError ? "Please enter your name" : ""}
                variant="outlined"
                fullWidth
                disabled={isSubmitting}
              />
              <TextField
                key="email-field"
                required
                id="outlined-required-email"
                label="Email / Phone"
                placeholder="How can I reach you?"
                value={email}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  console.log('Email input:', e.target.value); // Debug log (remove later)
                  setEmail(e.target.value);
                  if (emailError) setEmailError(false);
                }}
                error={emailError}
                helperText={emailError ? "Please enter your email or phone number" : ""}
                variant="outlined"
                fullWidth
              />
            </div>
            <TextField
              key="message-field"
              required
              id="outlined-multiline-static"
              label="Message"
              placeholder="Send me any inquiries or questions"
              multiline
              rows={10}
              className="body-form"
              value={message}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                console.log('Message input:', e.target.value); // Debug log (remove later)
                setMessage(e.target.value);
                if (messageError) setMessageError(false);
              }}
              error={messageError}
              helperText={messageError ? "Please enter the message" : ""}
              variant="outlined"
              fullWidth
            />
            <Button 
              type="submit" // Triggers onSubmit automatically
              variant="contained" 
              endIcon={<SendIcon />} 
              // No onClick needed - onSubmit handles it
            >
              Send
            </Button>
          </Box>
        </div>
      </div>
    </div>
  );
}

export default Contact;